import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import Timestamp from "./utils/Timestamp";
import Address from "./common/Address";
import Transaction from "./common/Transaction";

const Event = ({timestamp, who, action, txHash, img}) => {
  return (
    <Container>
      <Row>
        <div>{Timestamp.unixTimestampToDateString(timestamp)} <Address address={who}/> {action}: <Transaction txHash={txHash} format={true}/></div>
      </Row>
    </Container>
  )
};

export default Event;